module.exports = __webpack_public_path__ + "img/besancon.18471388.png";